<template>
  <div class="main">
    <!-- 标题 -->
    <div class="herder-title">{{ code ? "注册绑定" : "账号注册" }}</div>

    <!-- 输入框 -->
    <div class="input-box1">
      <input v-model="phone" placeholder="请输入手机号码" />
      <div class="left">
        +86 <img src="@/assets/mobile/image/common/arrow.png" />
      </div>
    </div>
    <div class="input-box3">
      <input v-model="validCode" placeholder="请输入短信验证码" />
      <button
        :class="timer ? 'timer right' : 'right'"
        :disabled="timer"
        @click="doGeetest"
      >
        {{ timer ? time + "s 后获取" : "获取验证码" }}
      </button>
    </div>
    <div class="input-box2">
      <input v-model="password" :type="type" placeholder="请输入注册密码" />
      <div class="right">
        <img
          @click="type = 'text'"
          v-if="type === 'password'"
          src="@/assets/mobile/image/common/close.png"
        />
        <img
          @click="type = 'password'"
          v-if="type === 'text'"
          src="@/assets/mobile/image/common/open.png"
        />
      </div>
    </div>

    <div class="input-box2">
      <input
        v-model="confirmPassword"
        :type="type2"
        placeholder="请输入确认密码"
      />
      <div class="right">
        <img
          @click="type2 = 'text'"
          v-if="type2 === 'password'"
          src="@/assets/mobile/image/common/close.png"
        />
        <img
          @click="type2 = 'password'"
          v-if="type2 === 'text'"
          src="@/assets/mobile/image/common/open.png"
        />
      </div>
    </div>

    <!-- 登录按钮 -->
    <button class="btn" @click="setRegistry">注册</button>

    <!-- 验证码登录 -->
    <div class="code" @click="gourl('/mobile/login')">账号密码登录</div>

    <div class="radio-box">
      <van-radio-group v-model="radio">
        <van-radio name="1"></van-radio>
      </van-radio-group>
      <div class="radio-name">
        注册即代表同意《爱答卷》<span>用户协议</span>和<span>隐私政策</span>
      </div>
    </div>
  </div>
</template>
<script>
import { geetestMixin } from "@/mixin/geetest.mixin";
import { getCaptcha, getRegistryCode, setRegistry } from "@/api/mobile";
export default {
  data() {
    return {
      radio: null,
      type: "password",
      type2: "password",
      timer: null,
      time: 180,
      base64: null,
      passwordType: "password",
      phone: null,
      password: null,
      confirmPassword: null,
      captchaCode: null,
      captchaKey: null,
      validCode: null,
      channelId: null,
      channelUserId: null,
      referrerId: null,
      code: null,
    };
  },
  mixins: [geetestMixin],
  methods: {
    gourl(path) {
      if (this.code) {
        this.$router.push(path + "?code=" + this.code);
      } else {
        this.$router.push(path);
      }
    },

    //验证码
    getCaptcha() {
      getCaptcha().then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.captchaKey = res.data.id;
          this.base64 = "data:image/png;base64," + res.data.base64;
        }
      });
    },
    //手机验证码
    doGeetest() {
      if (!this.phone) {
        this.$toast("请先填写手机号");
        return;
      }

      if (!this.geetest.geetestObj) {
        /*
            如果this.geetest.geetestFatched==true，则说明已经加载过极验了
            如果this.geetest.showGeetest==false，则说明后台关闭极验了
           */
        if (this.geetest.geetestFatched && !this.geetest.showGeetest) {
          this.confirmSendVerifyCode();

          console.log("触发--1");
        } else {
          this.initGeetest({
            product: "bind",
            lang: this.getLang.code,
          });

          console.log("触发00");
        }
      } else {
        console.log("触发测试");
        if (this.geetest.showGeetest) {
          this.geetestShow();
          console.log("触发111");
        } else {
          console.log("触发222");
          this.getRegistryCode();
        }
      }
    },
    getRegistryCode() {
      getRegistryCode({
        phone: this.phone,
        geetestChallenge: this.geetest.geetestSuccessData.geetest_challenge,
        geetestValidate: this.geetest.geetestSuccessData.geetest_validate,
        geetestSeccode: this.geetest.geetestSuccessData.geetest_seccode,
      }).then((res) => {
        if (res.code === 200) {
            this.$toast("验证码已发送，请注意接听手机");
          this.timer = setInterval(() => {
            this.time = this.time - 1;
            if (this.time === 1) {
              this.time = 180;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      });
    },
    // 极验验证成功后回调
    onGeetestSuccess() {
      // 用户通过极验行为验证后做的操作
      this.getRegistryCode();
    },
    // 极验被禁用后回调
    onDisableGeetest() {
      this.getRegistryCode();
    },

    //注册
    setRegistry() {
      if (!this.radio) {
        this.$toast("请先同意隐私政策和服务协议");
        return;
      }
      setRegistry({
        phone: this.phone,
        password: this.password,
        confirmPassword: this.confirmPassword,
        validCode: this.validCode,
        captchaKey: this.captchaKey,
        captchaCode: this.captchaCode,
        yes: true,
        channelId: this.channelId,
        channelUserId: this.channelUserId,
        referrerId: this.referrerId,
        weChatCode: this.code,
      }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.$toast("注册成功");
          this.$router.push("/mobile/login");
        }
      });
    },
  },
  created() {
    this.getCaptcha();
    if (this.$route.query.web) {
      this.channelId = this.$route.query.web;
    }
    if (this.$route.query.uid) {
      this.channelUserId = this.$route.query.uid;
    }
    if (this.$route.query.refer) {
      this.referrerId = this.$route.query.refer;
    }

    if (this.$route.query.code) {
      this.code = this.$route.query.code;
    }
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  min-height: calc(100vh - 125px);
  background-color: #faf8ff;
  background-image: url("../../assets/mobile/image/common/shadow.png");
  background-size: cover;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 85px;
  padding-bottom: 40px;
  .herder-title {
    text-align: center;
    color: #232323;
    font-size: 23px;
    font-weight: bolder;
  }
  .input-box1 {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 334px;
    background: #ffffff;
    border-radius: 29px 29px 29px 29px;
    margin-top: 31px;
    input {
      height: 50px;
      width: 100%;
      border: none;
      outline: none;
      font-size: 16px;
      color: #232323;
      border-radius: 29px 29px 29px 29px;
      box-sizing: border-box;
      padding: 0 20px 0 70px;
    }
    .left {
      position: absolute;
      color: #232323;
      font-size: 16px;
      display: flex;
      align-items: center;
      left: 20px;
      img {
        width: 10px;
        height: 10px;
        margin-left: 2px;
      }
    }
  }

  .input-box2 {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 334px;
    height: 50px;
    background: #ffffff;
    border-radius: 29px 29px 29px 29px;
    margin-top: 15px;
    input {
      height: 50px;
      width: 100%;
      border: none;
      outline: none;
      font-size: 16px;
      color: #232323;
      border-radius: 29px 29px 29px 29px;
      box-sizing: border-box;
      padding: 0 54px 0 20px;
    }
    .right {
      position: absolute;
      color: #232323;
      font-size: 16px;
      display: flex;
      align-items: center;
      right: 20px;
      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
  }
  .input-box3 {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 334px;
    background: #ffffff;
    border-radius: 29px 29px 29px 29px;
    margin-top: 15px;
    input {
      height: 50px;
      width: 100%;
      border: none;
      outline: none;
      font-size: 16px;
      color: #232323;
      border-radius: 29px 29px 29px 29px;
      box-sizing: border-box;
      padding: 0 110px 0 20px;
    }
    .right {
      position: absolute;
      right: 20px;
      color: #8846ff;
      font-size: 16px;
      cursor: pointer;
      border: none;
      background-color: #fafafa;
    }
    .timer {
      cursor: no-drop;
      opacity: 0.5;
    }
  }
  .input-box4 {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 334px;
    height: 50px;
    border-radius: 29px 29px 29px 29px;
    margin-top: 15px;
    input {
      height: 50px;
      width: 100%;
      border: none;
      outline: none;
      font-size: 16px;
      color: #232323;
      border-radius: 29px 29px 29px 29px;
      box-sizing: border-box;
      padding: 0 20px 0 20px;
    }
    .right {
      flex-shrink: 0;
      width: 100px;
      height: 50px;
      margin-left: 20px;
      img {
        width: 100px;
        height: 50px;
        cursor: pointer;
      }
    }
  }
  //忘记密码
  .forgot-password {
    color: #8846ff;
    font-size: 14px;
    text-align: center;
    margin-top: 17px;
  }
  //登录按钮
  .btn {
    padding: 0;
    border: none;
    width: 90%;
    max-width: 334px;
    height: 50px;
    background: linear-gradient(138deg, #c2a0ff 0%, #8846ff 100%);
    border-radius: 25px 25px 25px 25px;
    color: #fff;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 80px;
    font-size: 16px;
    cursor: pointer;
  }
  //验证码登录
  .code {
    color: #8846ff;
    font-size: 14px;
    text-align: center;
    margin-top: 15px;
    cursor: pointer;
  }

  //其它方式登录
  .other {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666666;
    font-size: 12px;
    margin-top: 80px;
    span {
      width: 41px;
      height: 1px;
      background: #eeedf2;
      margin: 0 18px;
    }
  }
  .weixin {
    width: 32px;
    height: 32px;
    margin-top: 11px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  .radio-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 49px;
    .radio-name {
      font-size: 12px;
      margin-left: 5px;
      span {
        color: #8846ff;
      }
    }
  }
}
</style>
<style>
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #c1c1c1;
  opacity: 1;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c1c1c1;
  opacity: 1;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c1c1c1;
  opacity: 1;
}
:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #c1c1c1;
  opacity: 1;
}
.main >>> .van-radio__label {
  font-size: 12px;
}
</style>